import React from 'react'
import { css, cx } from '@emotion/css'
import { Panel } from '../../components/sliding-tutorial'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'

interface GridDrilldownPanelProps {
  readonly renderPanelActions?: (props: {
    readonly actionsIconCss: string
  }) => any
  readonly isOpen: boolean
  readonly onClose: () => void
  readonly renderBody: () => any
  readonly yOffset: number
  readonly containerOverflow?: boolean
  readonly customBodyContainerClassName?: string
  zIndex?: number
}

const getPanelCss = ({
  className,
  panelRightPosition,
  yOffset,
  isOpen,
  zIndex
}: {
  readonly className: string | undefined
  readonly panelRightPosition: number
  readonly yOffset: number
  readonly isOpen: boolean
  readonly zIndex: number
}) => {
  const panelSlideOutCss = css`
    transform: translateX(${panelRightPosition}px);
  `

  const panelCss = cx(
    css`
      z-index: ${zIndex};
      position: fixed;
      top: ${yOffset}px;
      right: ${panelRightPosition}px;
      height: -webkit-calc(100% - ${yOffset}px);
      height: -moz-calc(100% - ${yOffset}px);
      height: calc(100% - ${yOffset}px);
      transition: transform 250ms ease-in;
      width: 750px;
    `,
    className
  )
  return isOpen
    ? cx(panelCss, panelSlideOutCss)
    : cx(
        panelCss,
        css`
          transform: translateX(0);
        `
      )
}

// This is a generic "panel" that is made to appear over a data grid. It has a slide in/out animation.
export const GridDrilldownPanel = ({
  renderPanelActions,
  isOpen,
  onClose,
  renderBody,
  zIndex = 100,
  yOffset,
  containerOverflow = true,
  customBodyContainerClassName
}: GridDrilldownPanelProps) => {
  const bodyContainerCss = cx(
    css`
      padding-right: 80px;
    `,
    customBodyContainerClassName
  )

  return (
    <Panel
      dataTestid={`grid-drilldown-panel-${isOpen ? 'open' : 'closed'}`}
      className={getPanelCss({
        className: css`
          width: 67%;
          background-color: ${theme.color.white};
          border: 1px solid ${theme.color.neutral40};
          box-shadow: 1px 0 10px
            ${deprecatedTheme.secondaryColors.panelBoxShadow};
          ${!containerOverflow ? 'overflow: hidden' : ''};
        `,
        panelRightPosition: -2000,
        yOffset,
        isOpen,
        zIndex
      })}
      onClose={onClose}
      bodyContainerCss={bodyContainerCss}
      closeIconClassName={css`
        height: 15px;
        width: 15px;
      `}
      renderBody={isOpen ? renderBody : undefined}
      boxShadow={false}
      renderPanelActions={renderPanelActions}
    />
  )
}
